import { connect } from "react-redux";
import { generatePath, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constants";
import { general } from "../../../../store/action";
import Icon from "../../general/icon";
import { getCellValue } from "../../../../utils/utils";
import {MtoJFullDateFormat} from "../../../../utils/date";
import Tooltip from "../../general/tooltip";
import {useFindAccessInAccessList} from "../../../../constants/constant/accessProcess";

const DoctorCardsBoxItem = ({
  item,
  dataListTitles,
  handleShowModal
}) => {
  const navigate = useNavigate();
  const {findAccessInAccessList} = useFindAccessInAccessList();

  return(
    <div className="box-shadow rounded mb-4 px-4 py-3 mt-2 mx-2">
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="name">{dataListTitles[0]}</label>
        <span className="mr-2">{getCellValue(item?.firstName)} {getCellValue(item?.lastName)}</span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="specialty">{dataListTitles[1]}</label>
        <span className="mr-2">{getCellValue(item?.specialty?.name)}</span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="nationalCode">{dataListTitles[2]}</label>
        <span className="font-en mr-2">{getCellValue(item?.nationalCode)}</span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="mobile">{dataListTitles[3]}</label>
        <span className="mr-2">{getCellValue(item?.mobile)}</span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="medId">{dataListTitles[4]}</label>
        <span className="mr-2">{getCellValue(item?.medId)}</span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="updateDate">{dataListTitles[5]}</label>
        <span className="mr-2">
          <bdi>{getCellValue(MtoJFullDateFormat(item?.updateDate))}</bdi>
        </span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="banned">{dataListTitles[6]}</label>
        <span className="mr-2">
          {item?.banned ?
            <div>
            <span className='bg-light-red text-red px-3 py-1 rounded text-nowrap'>
              غیر فعال
            </span>
            </div>
            :
            <div>
            <span className='px-3 py-1 text-green2 rounded text-nowrap' style={{backgroundColor: '#E6FAF2'}}>
              فعال
            </span>
            </div>
          }
        </span>
      </div>
      <div className="d-flex align-items-center justify-content-end my-3">
        <div className="d-flex align-items-center">
          {
            findAccessInAccessList('OPERATOR_CHANGE_BLOCK') &&
            <Tooltip alt={item?.banned ? 'فعال سازی حساب کاربری' : 'غیر فعال سازی حساب کاربری'} placement='bottom' className="tooltip-pre-line">
              <span
                onClick={() => handleShowModal('blockingUserModal', {accountId: item?.accountId, banned: item?.banned})}
                className={`d-flex mx-2 font-20 cur-pointer ${item?.banned ? 'text-hover' : 'text-red-hover'}`}
              >
                <Icon name={item?.banned ? 'check-square' : 'close-square'}/>
              </span>
            </Tooltip>
          }
          {
            findAccessInAccessList('OPERATOR_CHANGE_PASSWORD') &&
            <Tooltip alt={'تغییر کلمه عبور'} placement='bottom' className="tooltip-pre-line">
              <span
                onClick={() => handleShowModal('changeAccountPasswordModal', {firstName: item?.firstName, lastName: item?.lastName, accountId: item?.accountId})}
                className="d-flex text-hover mx-2 font-20 cur-pointer"
              >
                <Icon name='key'/>
              </span>
            </Tooltip>
          }
          {
            findAccessInAccessList('PROVIDER_VIEW') &&
            <Tooltip alt={'ویرایش'} placement='bottom' className="tooltip-pre-line">
              <span
                onClick={() => navigate(generatePath(ROUTES.DOCTOR_EDIT.PATH, {id: item?.id}))}
                className="d-flex text-hover mx-2 font-18 cur-pointer"
              >
                <Icon name='pen-square'/>
              </span>
            </Tooltip>
          }
          {
            findAccessInAccessList('PROVIDER_DELETE') &&
            <Tooltip alt={'حذف'} placement='bottom' className="tooltip-pre-line">
              <span
                onClick={() => handleShowModal('deleteDoctorModal', item?.id)}
                className="d-flex text-red-hover mr-2 font-20 cur-pointer"
              >
                <Icon name='trash'/>
              </span>
            </Tooltip>
          }
        </div>
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  handleShowModal: (data, body) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(DoctorCardsBoxItem);